import { DependencyList, RefObject } from 'react';

export interface IDailyQuestion {
  isDarkTheme?: boolean;
  isCinemaWeek?: boolean;
}

export type TUseContentAnalytics = (
  ref: RefObject<HTMLDivElement>,
  deps: DependencyList | undefined
) => void;
